import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const initialState = {
  searchGroup: '',
  groupSorting: { ...initialSorting },
};

const useManageFacilityStore = createStore(
  (set) => ({
    ...initialState,

    actions: {
      setSearchGroup: (searchGroup) => set({ searchGroup }),
      setGroupSorting: (groupSorting) => set({ groupSorting }),
      setManageFacilityReset: () => set({ ...initialState }),
    },
  }),
  'manageFacilityStore',
);

export const useManageFacilityStoreActions = () => useManageFacilityStore((state) => state.actions);

export const selectSearchGroup = () => useManageFacilityStore((state) => state.searchGroup);
export const selectGroupSorting = () => useManageFacilityStore((state) => state.groupSorting);
